import React from 'react';
import Typography from '@material-ui/core/Typography';
import {TypographyProps, withStyles} from '@material-ui/core';

import DataUnavailableBox from '../DataUnavailableBox';
import InfoTooltip from '../InfoTooltip';

const StyledTypography = withStyles<string, undefined, TypographyProps>(theme => ({
    root: {
        fontWeight: 'normal',
        cursor: 'pointer',
        minWidth: '200px',
        maxWidth: 'calc(100vw - 20rem)',

        [theme.breakpoints.up('fmd')]: {
            maxWidth: 'calc(100vw / 2 - 15rem)'
        },
        [theme.breakpoints.up('flg')]: {
            maxWidth: '200px'
        },
        [theme.breakpoints.up('xl')]: {
            maxWidth: '300px'
        }
    }
}))(Typography);

export interface MyTopPerformingGamesCardContentProps {
    title: string;
    value?: string;
    previousValue?: string;
    code?: string;
    tooltip?: JSX.Element | string;
}

const MyTopPerformingGamesCardContent = ({
    title,
    value,
    code,
    tooltip,
    previousValue
}: MyTopPerformingGamesCardContentProps) =>
    value ? (
        <InfoTooltip value={value} code={code}>
            <StyledTypography noWrap variant="h3">
                {value}
            </StyledTypography>
        </InfoTooltip>
    ) : (
        <DataUnavailableBox title={title} previousValue={previousValue} tooltip={tooltip} />
    );

export default MyTopPerformingGamesCardContent;
